module.exports = __webpack_public_path__ + "static/media/signal-alt-slash.2745020c.svg";